export const loginTeaserStyle = {
  teaserContainer: {
    padding: "20px",
    color: "#ffffff",
  },
};
